import axiosInstance from '../axios/axios-instance';
import { ContinueDealResponseDto } from 'shared/interfaces/deal/continue-deal-response.dto';
import { DealViewDetailsDto } from 'shared/interfaces/deal/deal-view-details.dto';
import { StartDealRequestDto } from 'shared/interfaces/deal/start-deal-request.dto';
import { StartDealResponseDto } from 'shared/interfaces/deal/start-deal-response.dto';
import { ViewDealRequestDto } from 'shared/interfaces/deal/view-deal-request.dto';

export const dealApi = {
  async viewDeal(request: ViewDealRequestDto): Promise<DealViewDetailsDto> {
    const response = await axiosInstance.post<DealViewDetailsDto>('/deal/view', request);
    return response.data;
  },

  async startDeal(request: StartDealRequestDto): Promise<StartDealResponseDto> {
    const response = await axiosInstance.post<StartDealResponseDto>('/deal/start', request);
    return response.data;
  },

  async continueDeal(sessionUid: string): Promise<ContinueDealResponseDto> {
    const response = await axiosInstance.post<ContinueDealResponseDto>('/deal/continue', { sessionUid });
    return response.data;
  },
};
